var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2_ui_view_screen_folders_tree",
    transform: "translate(-212.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline-search-24px",
    transform: "translate(210.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.7204117,11.4339623 L12.0428816,11.4339623 L11.8027444,11.2024014 C12.6432247,10.2246998 13.1492281,8.95540309 13.1492281,7.57461407 C13.1492281,4.49571184 10.6535163,2 7.57461407,2 C4.49571184,2 2,4.49571184 2,7.57461407 C2,10.6535163 4.49571184,13.1492281 7.57461407,13.1492281 C8.95540309,13.1492281 10.2246998,12.6432247 11.2024014,11.8027444 L11.4339623,12.0428816 L11.4339623,12.7204117 L15.7221269,17 L17,15.7221269 L12.7204117,11.4339623 Z M7.57461407,11.4339623 C5.43910806,11.4339623 3.71526587,9.71012007 3.71526587,7.57461407 C3.71526587,5.43910806 5.43910806,3.71526587 7.57461407,3.71526587 C9.71012007,3.71526587 11.4339623,5.43910806 11.4339623,7.57461407 C11.4339623,9.71012007 9.71012007,11.4339623 7.57461407,11.4339623 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9aabbf75.svg";
export { ForwardRef as ReactComponent };